<div class="set-password-container">
  <div class="set-password-card">
    <div class="row justify-content-center">
      <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
        <img src="assets/images/edu-logo.svg" alt="{{genericMessage['G0001']}}" class="img-fluid" />
      </div>
    </div>
    <div class="horizontal-line mb-0 mt-2"></div>
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
      <h1 class="page-title1 justify-content-center mt-3" *ngIf="islea">Local Education Agency (LEA) Registration</h1>
      <h1 class="page-title1 justify-content-center mt-3" *ngIf="isFp">Fingerprint Vendor Registration</h1>
      <h1 class="page-title1 justify-content-center mt-3" *ngIf="isEpp">Educator Preparation Provider (EPP) Registration</h1>
      <div class="form-content">
        <h1 class="page-title mt-3">Create Your Password</h1>
       
         <div class="text-field mb-4" *ngIf="shouldShowEmailField()">
          <div class="field-label">
            <label for="emailDisplay">Email</label>
          </div>
          <div class="input-container email">
            <input
              type="email"
              id="emailDisplay"
              [value]="email"
              readonly
              class=""
              disabled
              placeholder="Email Address"
            />
          </div>
        </div>
 
        <div class="text-field">
          <div class="field-label">
            <label for="password">New Password</label>
            <span class="required">*</span>
          </div>
          <div class="input-container " [ngClass]="{
                'is-invalid': passwordForm.get('password')?.touched && passwordForm.get('password')?.invalid
              }">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              required
              (keydown)="checkCapsLock($event, 'new')"
              (keyup)="checkCapsLock($event, 'new')"
              (focus)="checkCapsLock($event, 'new')"
              (blur)="hideCapsLockWarning('new')"
              (input)="checkPasswordValidation()"
              placeholder="Enter New Password"
               />
            <button aria-live="polite" aria-atomic="true"
              type="button"
              class="password-view"
              (click)="togglePasswordVisibility()"
              aria-label="Toggle password visibility">
              <span [ngClass]="{ 'pi-eye': showPassword, 'pi-eye-slash': !showPassword }" class="pi"></span>
            </button>
          </div>
        </div>
        <div *ngIf="isCapsLockOnNew" class="mt-2 text-danger err-font">
          {{ errorMessage['M0037'] }}
        </div>
        <div  *ngIf="passwordForm.get('password')?.touched && passwordForm.get('password')?.errors as errors"
        class="mt-0 mb-3">
          <div class="validation-item" class="text-danger  err-font">
            {{ errorMessage['M0026'] }}
          </div>
        </div>
        <div class="validation-list" *ngIf="passwordForm.get('password')?.value && !allValidationsPass">
          <div class="validation-item" [ngClass]="{ valid: validations.minLength }">
            {{ errorMessage['M0027'] }}
          </div>
          <div class="validation-item" [ngClass]="{ valid: validations.uppercase }">
            {{ errorMessage['M0028'] }}
          </div>
          <div class="validation-item" [ngClass]="{ valid: validations.lowercase }">
            {{ errorMessage['M0029'] }}
          </div>
          <div class="validation-item" [ngClass]="{ valid: validations.number }">
            {{ errorMessage['M0030'] }}
          </div>
          <div class="validation-item" [ngClass]="{ valid: validations.specialChar }">
            {{ errorMessage['M0031'] }}
          </div>
          <div class="validation-item" [ngClass]="{ valid: validations.noPersonalInfo }">
            {{ errorMessage['M0032'] }}
          </div>
          <div class="validation-item" [ngClass]="{ valid: validations.alphanumeric }">
            {{ errorMessage['M0033'] }}
          </div>
        </div>

        <div class="text-field mt-4">
          <div class="field-label">
            <label for="confirmPassword">Confirm Password</label>
            <span class="required">*</span>
          </div>

          <div class="input-container"  [ngClass]="{
                'is-invalid': passwordForm.get('confirmPassword')?.touched && passwordForm.get('confirmPassword')?.invalid
              }">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirmPassword"
              formControlName="confirmPassword"
              (keydown)="checkCapsLock($event, 'confirm')"
              (keyup)="checkCapsLock($event, 'confirm')"
              (focus)="checkCapsLock($event, 'confirm')"
              (blur)="hideCapsLockWarning('confirm')"
              placeholder="Confirm New Password"
              Inputfocus
              />

            <button
              type="button"
              class="password-view"
              (click)="toggleConfirmPasswordVisibility()"
              aria-label="Toggle password visibility" aria-live="polite" aria-atomic="true">
              <span
                [ngClass]="{ 'pi-eye': showConfirmPassword, 'pi-eye-slash': !showConfirmPassword }"
                class="pi"></span>
            </button>
          </div>
        </div>
        <div *ngIf="isCapsLockOnConfirm" class="mt-2 text-danger err-font">
          {{ errorMessage['M0037'] }}
        </div>
        <div  *ngIf="passwordForm.get('confirmPassword')?.touched && passwordForm.get('confirmPassword')?.errors as errors"
        class="mt-0 mb-2">
          <div class="validation-item" class="text-danger  err-font">
            {{ errorMessage['M0035'] }}
          </div>
        </div>
        <div
          class="validation-list"
          *ngIf="passwordForm.get('confirmPassword')?.value && (!passwordForm.valid || !allValidationsPass)">
          <div class="validation-item text-danger" [ngClass]="{ mismatch: !passwordForm.valid || !allValidationsPass }">
            {{ errorMessage['M0036'] }}
          </div>
        </div>
        <button
          type="submit"
          class="submit-button"
          [disabled]="!passwordForm.valid || !allValidationsPass || isLoading">
           <span *ngIf="isLoading"
           class="spinner-border spinner-border-sm" output="status" aria-hidden="true"></span>
          {{ getButtonText() }}
        </button>
      </div>
    </form>
  </div>
</div>